import InputText from '@/trio-ui/InputText';
import Modal from '@/trio-ui/Modal';
import { ModalCustomProps } from '@/trio-ui/Modal/Modal.component';
import { PTORequest, PTOStatus } from '@/types/api';
import { StaffMember } from '@/types/api/staffMember';
import { getPTORequestIntervalText, getTotalPTORequestHours, ptoTypeLabel } from '@/utils/pto';
import { ModalText } from './AnswerTimeoffRequestModal.styles';

export type Props = Pick<ModalCustomProps, 'isOpen' | 'onClose'> & {
  newStatus: PTOStatus.APPROVED | PTOStatus.DENIED;
  staffMember?: StaffMember;
  request: PTORequest;
  comment: string;
  setComment: (value: string) => void;
  onConfirmClick: () => void;
  isDisabled?: boolean;
};

const AnswerTimeoffRequestModal = ({
  newStatus,
  staffMember,
  request,
  comment,
  setComment,
  onConfirmClick,
  isDisabled = false,
  ...modalProps
}: Props): JSX.Element => {
  const newStatusText = newStatus === PTOStatus.APPROVED ? 'approval' : 'denial';
  const totalOfHours = getTotalPTORequestHours(request);

  const RequestAnswerModalBody = (
    <div data-testid="pto-request-answer-modal">
      <ModalText>
        Please confirm the {newStatusText} for{' '}
        {`${staffMember?.person.firstName}${
          staffMember?.person.lastName ? ` ${staffMember?.person.lastName}` : ''
        }`}
        ’s request {totalOfHours} hrs of {ptoTypeLabel[request.ptoType]} for{' '}
        {getPTORequestIntervalText(request)}.
      </ModalText>
      <InputText
        value={comment}
        name="comment"
        onChangeHandler={(e) => setComment(e.target.value)}
        isLabelAboveField
        placeholder="Comment"
        marginBlockStart="17px"
      />
    </div>
  );

  return (
    <Modal
      modalId="pto-request-answer"
      isCentered
      size="sm"
      onConfirmClick={onConfirmClick}
      modalTitle="Are you sure?"
      onConfirmLabel="Submit"
      bodyRender={RequestAnswerModalBody}
      isButtonDisabled={isDisabled}
      {...modalProps}
    />
  );
};

export default AnswerTimeoffRequestModal;
